const formContextKey = Symbol("formContextKey");
const formItemContextKey = Symbol("formItemContextKey");

export { formContextKey, formItemContextKey };
//# sourceMappingURL=form.mjs.map
